import React from "react";
import { CardContent, Grid } from "@mui/material";
import RenderFormFieldBuilder from "./RenderFormFieldBuilder";
import { State } from "@hookstate/core";
import type { formFields } from "~/features/Dispatch/interfaces/IDispatchFormBuilder";

interface FormBuilderHospitalProps {
  readonly dataForm: State<formFields[]>;
}

export default function FormBuilderOccurrencePeople({ dataForm }: FormBuilderHospitalProps) {
  return (
    <CardContent>
      <Grid
        container
        direction={'row'}
        justifyContent={'flex-start'}
        alignItems={'baseline'}
      >
        <RenderFormFieldBuilder fields={dataForm} />
      </Grid>
    </CardContent>
  )
}
